// Where a floating dropdown goes relative to its trigger — pure, so the
// static suite proves the rule without a browser.
//
// The dropdown is position:fixed (see SearchableSelect.jsx), anchored to the
// trigger's viewport rect. It used to open downward only, so a select near the
// bottom of the window ran off the viewport with nothing to scroll (the
// Configure Screen "add a field" box on the first greenfield tenant,
// 2026-08-26). Rule: open below when the dropdown fits below; otherwise open
// on whichever side has more room.
//
// rect: { top, bottom, left, width } in viewport px (getBoundingClientRect)
// dropdownHeight: measured px (fall back to an estimate before first paint)
// viewportHeight: window.innerHeight
// Returns { top } (below) or { bottom } (above) — fixed-position offsets — plus
// left/width, and `direction` for callers/tests.
function placeDropdown({ rect, dropdownHeight, viewportHeight, gap = 4 }) {
  const spaceBelow = viewportHeight - rect.bottom - gap;
  const spaceAbove = rect.top - gap;
  const below = dropdownHeight <= spaceBelow || spaceBelow >= spaceAbove;
  const base = { left: rect.left, width: rect.width };
  return below
    ? { ...base, direction: 'below', top: rect.bottom + gap }
    : { ...base, direction: 'above', bottom: viewportHeight - rect.top + gap };
}

export { placeDropdown };
